<!-- :src/layouts/DashboardLayout.vue -->
<template>

    <div class="app-wrapper">
      <!--begin::Header-->
        <navebar :users="users" @logout="handleLogout" @toggle-sidebar="handleToggleSidebar" ></navebar>
      <!--end::Header-->
      <!--begin::Sidebar-->
        <Sidebar :users="users" ></Sidebar>
      <!--end::Sidebar-->
      <!--begin::App Main-->
      <main class="app-main">
        <!--begin::App Content Header-->
        <!-- <div class="app-content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"><h3 class="mb-0">Layout RTL</h3></div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-end">
                  <li class="breadcrumb-item"><a href="#">Home</a></li>
                  <li class="breadcrumb-item active" aria-current="page">Layout RTL</li>
                </ol>
              </div>
            </div>
          </div>
        </div> -->
        <!--end::App Content Header-->
        <!--begin::App Content-->
        <div class="app-content">
          <!--begin::Container-->
          <div class="container-fluid">
            <!--begin::Row-->
            <div class="row">
               <router-view />
            <!--end::Row-->
          </div>
          <!--end::Container-->
        </div>
        </div>
        <!--end::App Content-->
      </main>
      <!--end::App Main-->
      <!--begin::Footer-->
      <footer class="app-footer">
        <!--begin::To the end-->
        <!-- <div class="float-end d-none d-sm-inline">Anything you want</div> -->
        <!--end::To the end-->
        <!--begin::Copyright-->
        <strong>
         نسخة مجانية خلال عملي داخل الكنترول لعام  &copy; 2025-2026&nbsp;
          <a href="#" class="text-decoration-none">Amr shaban Badawy</a>.
        </strong>
      
        <!--end::Copyright-->
      </footer>
      <!--end::Footer-->
    </div>
    <!-- <div class="dashboard-layout" :class="{ 'sidebar-is-open': isSidebarOpen }">
       
       
       
       
        <Sidebar :users="users" @logout="handleLogout" />

    
        <div class="sidebar-overlay" @click="isSidebarOpen = false"></div>

        <main class="main-content">
            <div class="mobile-header">
                <button @click="isSidebarOpen = !isSidebarOpen" class="sidebar-toggler">
                    <i class="fas fa-bars"></i>
                </button>
                <h4 class="mobile-header-title">مسابقة تارجت</h4>
            </div>

            <router-view />
        </main>
    </div> -->
</template>

<script>
import Sidebar from '../components/Sidebar.vue';
import navebar from '../components/_Nav.vue';

export default {
    name: 'DashboardLayout',
    components: {
        Sidebar,
        navebar
    },
    data() {
        return {
            isSidebarOpen: false,
            // بيانات المستخدم يجب جلبها من Vuex أو API بعد تسجيل الدخول
            users: {
                name: '',
                role: '' // أو 'contestant'
            }
        };
    },
    methods: {
        handleLogout() {
        localStorage.clear();
            this.$router.push({ name: 'Home' }); // مثال: توجيه لصفحة الدخول
        },
    handleToggleSidebar() {
    // نتحكم في كلاسات الـ body مباشرة لأن AdminLTE يعتمد عليها
    const body = document.querySelector('body');
    
    // التحقق من حجم الشاشة لمعرفة السلوك المناسب
    if (window.innerWidth < 992) {
      // للموبايل: يضيف كلاس لفتح القائمة
      if (body.classList.contains('sidebar-open')) {
        body.classList.remove('sidebar-open');
        body.classList.add('sidebar-closed');
      } else {
        body.classList.add('sidebar-open');
        body.classList.remove('sidebar-closed');
      }
    } else {
      // للكمبيوتر: يضيف كلاس لطي القائمة
      body.classList.toggle('sidebar-collapse');
    }
  },
    },
    watch: {
        // إذا انتقل المستخدم لصفحة أخرى، قم بإغلاق الشريط الجانبي (مفيد للموبايل)
        '$route'() {
            this.isSidebarOpen = false;
        }
    },
    mounted () {
      
        this.users =  JSON.parse(localStorage.getItem('user'));
       
        
    }, 
};
</script>

<style>
/* =============================================
   تنسيقات هيكل الصفحة (RTL Layout Fixes)
   ============================================= */

/* 1. التنسيق العام للحاوية */
.app-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
  direction: rtl;
}

/* 2. السايد بار (الإصلاح الجذري) */
.app-sidebar {
  /* نستخدم !important لفرض الـ fixed وإلغاء الـ sticky القادم من AdminLTE */
  position: fixed !important; 
  top: 0;
  right: 0; 
  bottom: 0;
  width: 260px;
  height: 100vh;
  z-index: 1038;
  transition: width 0.3s ease-in-out, transform 0.3s ease-in-out;
  background-color: #343a40;
  overflow-y: auto; /* للسماح بالسكرول داخل القائمة إذا كانت طويلة */
}

/* 3. المحتوى، الهيدر، والفوتر */
.app-main, 
.app-footer, 
.app-header {
  /* حجز مساحة للسايدبار */
  margin-right: 287px !important; 
  margin-left: 0 !important;
  transition: margin-right 0.3s ease-in-out;
  width: auto;
}

/* =============================================
   حالات التبديل (Toggle States)
   ============================================= */

/* A. حالة غلق السايد بار على الكمبيوتر (Sidebar Collapse) */
body.sidebar-collapse .app-sidebar {
  width: 0px !important;
  transform: translateX(100%); /* نضمن إخفاءه تماماً */
}

body.sidebar-collapse .app-main,
body.sidebar-collapse .app-footer,
body.sidebar-collapse .app-header {
  /* تمدد المحتوى ليأخذ كامل الشاشة */
  margin-right: 0px !important; 
}

/* B. تنسيقات الموبايل (أقل من 992px) */
@media (max-width: 991.98px) {
  
  /* الوضع الافتراضي في الموبايل: السايد بار مخفي */
  .app-sidebar {
    transform: translateX(100%); 
    width: 260px !important; /* نثبت العرض */
  }

  /* المحتوى في الموبايل دائماً كامل العرض */
  .app-main, 
  .app-footer, 
  .app-header {
    margin-right: 0 !important;
    width: 100%;
  }

  /* حالة فتح السايد بار في الموبايل */
  body.sidebar-open .app-sidebar {
    transform: translateX(0); 
    box-shadow: 0 10px 20px rgba(0,0,0,0.5);
  }
}

/* طبقة التعتيم للموبايل */
.sidebar-overlay {
  display: none;
  position: fixed;
  top: 0; left: 0; width: 100vw; height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1037;
  cursor: pointer;
}
:global(body.sidebar-open) .sidebar-overlay {
  display: block;
}
</style>